// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const TogetherArrowRight = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x={0.5} y={0.5} width={47} height={47} rx={23.5} fill="#000" fillOpacity={0.6} />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M22.667 34a1.333 1.333 0 0 1-.943-2.276L29.448 24l-7.724-7.724a1.334 1.334 0 0 1 1.885-1.886l8.667 8.667c.521.52.521 1.365 0 1.886l-8.667 8.666c-.26.26-.601.39-.942.39Z"
			fill="#fff"
		/>
		<rect x={0.5} y={0.5} width={47} height={47} rx={23.5} stroke="#fff" />
	</svg>
);
export default TogetherArrowRight;
